import React, {
  forwardRef
} from "react";
import { cx } from "@linaria/core";
import { CheckboxWrapper, HiddenCheckbox } from "./Checkbox.styles";
export const Checkbox = forwardRef(({
  id,
  checked = false,
  indeterminate = false,
  className = "",
  label = "",
  value = "",
  testId = "Checkbox",
  field = {
    name: "",
    value: []
  },
  form = {},
  disabled,
  ...rest
}, ref) => {
  const { name, value: selectedValues = [] } = field;
  const valueIsInSelectedValues = !!value && typeof selectedValues !== "boolean" && selectedValues.indexOf(value) !== -1;
  const isChecked = checked || valueIsInSelectedValues;
  const isIndeterminate = indeterminate && !isChecked;
  const { setFieldValue } = form;
  const handleOnChange = () => {
    let newValue = selectedValues;
    if (typeof newValue !== "boolean" && typeof selectedValues !== "boolean") {
      const index = selectedValues.indexOf(value);
      if (index === -1) {
        newValue.push(value);
      } else {
        newValue.splice(index, 1);
      }
    } else {
      newValue = !selectedValues;
    }
    if (setFieldValue)
      setFieldValue(name, newValue);
  };
  return /* @__PURE__ */ React.createElement(CheckboxWrapper, {
    "data-testid": testId,
    className: cx(disabled && "checkbox__disabled", className)
  }, /* @__PURE__ */ React.createElement(HiddenCheckbox, {
    id,
    type: "checkbox",
    "aria-checked": isIndeterminate ? "mixed" : isChecked,
    checked: isChecked,
    onChange: handleOnChange,
    value,
    ref,
    disabled,
    ...rest
  }), /* @__PURE__ */ React.createElement("div", {
    className: cx("checkbox__outline", (isChecked || isIndeterminate) && "checkbox__outline__checked")
  }, isChecked && /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: "checkbox__svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M5 9.09 6.8 11 11 6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), isIndeterminate && /* @__PURE__ */ React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    className: "checkbox__svg"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M4 8h8",
    strokeLinecap: "round"
  }))), /* @__PURE__ */ React.createElement("span", {
    className: "checkbox__label"
  }, label));
});
export default Checkbox;
